import React, { useState } from "react";
import Popups from "../Modals/Popups";
import PersonalizedActionModal from "../Modals/PersonalizedActionModal";

export default function NewCricBuddyPortfolioContactUs() {
  const [show, setShow] = useState(false);
  return (
    <div className="horizontal-padding pb-5">
      <div className="cb-contact-us-bg">
        <div className="border-el-wrapper border-el-wrapper-contact-us">
          <span className="b1"></span>
          <span className="b2"></span>
          <div className="row">
            <div className="col-12">
              <h2 className="cb-contact-us-h2 mb-3">Have an idea?</h2>
              <h3 className="cb-contact-us-h3">
                Let’s bring your dream app to life with SprigStack.
              </h3>
              <button className="btn-17" onClick={() => setShow(true)}>
                <div className="text-container">
                  <label className="text">Connect with us</label>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Popups show={show} setShow={setShow} title="FREE CONSULTATION" size="lg">
        <PersonalizedActionModal />
      </Popups>
    </div>
  );
}
